import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourDoneKey, TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';
import { HiddenTourStep } from 'webapp/models-custom/tour/designer/option-hidden';

export default class DesignerChangeDateRangeTour extends TourBase {
	static keyForPersistantDone = TourDoneKey.DESIGNER__CHANGE_DATE_RANGE;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLES_DATE_RANGE_CHANGED;

	get id(): string {
		return TourId.DESIGNER__CHANGE_DATE_RANGE;
	}

	override get keyForPersistantDone(): string {
		return DesignerChangeDateRangeTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				allowStacked: true,
				attachTo: () => {
					return $('.designer-panel--right .date-range');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override end(): void {
		super.end();
		this.flowTourDesignerService.resetHiddenTourExplicitlyClosedStatus(
			HiddenTourStep.RIGHT_PANEL_HIDDEN,
		);
		this.flowTourDesignerService.resetHiddenTourExplicitlyClosedStatus(
			HiddenTourStep.VISUALIZATION_SECTION_HIDDEN,
		);
	}
}
